import { Box, Button, Modal, Table } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useQuery } from "@tanstack/react-query";
import React from "react";
import { useTranslation } from "react-i18next";
import { getFlagHistory } from "../../../../services/flag";
import { useParams } from "react-router-dom";
import { dateFormat } from "../../../../utils/dateFormat";
import dayjs from "dayjs";
import { flagStatuses, resolutionStatuses } from "../../../../utils/vars";

// flagData?.reviewStatusHistory && flagData?.reviewStatusHistory.slice(0, 3);

const HistoryModal = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [opened, { open, close }] = useDisclosure(false);

  const handleOpen = async () => {
    await refetch();
    open();
  };

  const { data, isLoading, refetch } = useQuery({
    queryKey: ["flag-history", id],
    queryFn: () => getFlagHistory(id),
    refetchOnWindowFocus: false,
    enabled: false,
  });

  const rows = data?.map(
    ({ id, date, resolutionStatus, reviewStatus, user, description }) => (
      <Table.Tr key={id}>
        <Table.Td>{dayjs(date).format(dateFormat)}</Table.Td>
        <Table.Td>{resolutionStatuses[resolutionStatus]}</Table.Td>
        <Table.Td>{flagStatuses[reviewStatus] || reviewStatus}</Table.Td>
        <Table.Td>{user?.name}</Table.Td>
        <Table.Td>{description}</Table.Td>
      </Table.Tr>
    ),
  );

  return (
    <Box>
      <Button loading={isLoading} variant="outline" onClick={handleOpen}>
        History
      </Button>
      <Modal size={1100} opened={opened} onClose={close} title="History" centered>
        <Table withColumnBorders>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>{t("flagDetails.amlHistoryTable.date")}</Table.Th>
              <Table.Th>
                {t("flagDetails.amlHistoryTable.resolutionStatus")}
              </Table.Th>
              <Table.Th>
                {t("flagDetails.amlHistoryTable.reviewStatus")}
              </Table.Th>
              <Table.Th>{t("flagDetails.amlHistoryTable.employee")}</Table.Th>
              <Table.Th>
                {t("flagDetails.amlHistoryTable.description")}
              </Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>{rows}</Table.Tbody>
        </Table>
      </Modal>
    </Box>
  );
};

export default HistoryModal;
